import { render, staticRenderFns } from "./SuppliersAdder.vue?vue&type=template&id=565ae366&scoped=true&"
import script from "./SuppliersAdder.vue?vue&type=script&lang=js&"
export * from "./SuppliersAdder.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersAdder.vue?vue&type=style&index=0&id=565ae366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ae366",
  null
  
)

export default component.exports